import { render, staticRenderFns } from "./HsStudentsImport.vue?vue&type=template&id=23c685cd&"
import script from "./HsStudentsImport.vue?vue&type=script&lang=js&"
export * from "./HsStudentsImport.vue?vue&type=script&lang=js&"
import style0 from "./HsStudentsImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports